import { useEffect, useState } from 'react';

import { Button } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import ButtonActionDelete from 'shared/components/Button/Action/ButtonActionDelete/ButtonActionDelete';
import ButtonActionDeleteEnforceConfirm from 'shared/components/Button/Action/ButtonActionDelete/ButtonActionDeleteEnforceConfirm';
import ButtonActionList, { ButtonActionListT } from 'shared/components/Button/Action/ButtonActionList/ButtonActionList';
import { APIErrorT } from 'shared/models/api';
import { APICallParams, APIInterfaceI } from 'utils/api';
import { useEntityNameForNav } from 'utils/hooks/providers/entity-name-for-nav-context';

import './SeeDetailsPage.scss';

import Loader from '../Loader';
import ViewDetails from '../ViewDetails';
import { ViewDetailsT } from '../ViewDetails/ViewDetails';

interface SeeDetailsPageProps {
  name: string;
  targetID: string;
  fromAPI: APIInterfaceI;
  apiCallParams?: APICallParams;
  defaultURI: string;
  onDeleteRedirectURI?: string;
  dataStructure: ViewDetailsT;
  actions?: Array<ButtonActionListT>;
  useDeleteEnforceConfirm?: boolean;
}
function SeeDetailsPage({
  name,
  targetID,
  fromAPI,
  apiCallParams,
  defaultURI,
  onDeleteRedirectURI,
  dataStructure,
  actions,
  useDeleteEnforceConfirm,
}: SeeDetailsPageProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [dataDetails, setdataDetails] = useState<any>({});
  const history = useHistory();
  const { setEntityNameForNav } = useEntityNameForNav();

  const loadData = () => {
    setIsLoading(true);
    fromAPI.getOne(targetID, apiCallParams)
      .then((resp: any) => {
        if (resp.status >= 400) {
          resp.json()
            .then((error: APIErrorT) => {
              toast.error(error?.message);
              const redirectTo = defaultURI.substr(0, defaultURI.lastIndexOf('/'));
              console.warn('Failed to get item - Redirect on', redirectTo);
              history.push(redirectTo);
              setIsLoading(false);
            });
        } else {
          resp.json()
            .then((data: any) => {
              setdataDetails(data);
              setEntityNameForNav(data?.name as string);
              setIsLoading(false);
            });
        }
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  if (isLoading) {
    return <Loader.Page />;
  }
  return (
    <div>
      <div className="title__header">
        <h1 className="text-first-letter-uppercase">{`${name} details`}</h1>
        <div className="title__header--actions">
          <ButtonActionList list={actions} />
          <Link to={`${defaultURI}/${targetID}/edit`}>
            <Button variant="contained" color="secondary">Edit</Button>
          </Link>
          {!useDeleteEnforceConfirm
            ? (
              <ButtonActionDelete
                targetId={targetID}
                api={fromAPI}
                apiCallParams={apiCallParams}
                messageComplement={`this ${name} named '${dataDetails.name}'`}
                redirectLocation={onDeleteRedirectURI || defaultURI}
              />
            )
            : (
              <ButtonActionDeleteEnforceConfirm
                targetId={targetID}
                targetName={dataDetails.name}
                api={fromAPI}
                apiCallParams={apiCallParams}
                messageComplement={`this ${name} named '${dataDetails.name}'`}
                redirectLocation={onDeleteRedirectURI || defaultURI}
              />
            )}
        </div>
      </div>
      <div className="see-details-page">
        <ViewDetails data={dataDetails} dataStructure={dataStructure} />
      </div>
    </div>
  );
}

export default SeeDetailsPage;
